import Item from './item'
import notification from 'element-ui/packages/notification'

export default class Agreement {
  constructor() {
    this._items = [];
    this.tab = '';
    this._filter = {
      direction: 0,
      contragentType: 1,
      contragent: 0,
      legal: 0,
      currency: 1,
    };
    this._mask = '';
  }

  get mask() {
    return this._mask;
  }

  set mask(value) {
    this._mask = value;
    this._items.forEach(agreement => agreement.mask = value);
  }

  get loading() {
    return !!this._items.find(agreement => agreement.loading);
  }

  get items() {
    return this._items;
  }

  get main() {
    return this.items.length ? this.items[0] : null;
  }

  get contragents() {
    return this.main ? this.main.contragents : [];
  }

  get legals() {
    return this.main ? this.main.legals : [];
  }

  get value() {
    return Math.round(this.items.reduce((sum, agreement) => Math.round(sum * 1000000000000 + agreement.sum * 1000000000000) / 1000000000000, 0) * 100) / 100;
  }

  get type1() {
    if (this.main) {
      return !!this.main._requests.find(i => i.type === 1);
    } else {
      return true;
    }
  }

  get type3() {
    if (this.main) {
      return !!this.main._requests.find(i => i.type === 3);
    } else {
      return true;
    }
  }

  get type7() {
    if (this.main) {
      return !!this.main._requests.find(i => i.type === 7);
    } else {
      return true;
    }
  }

  set value(value) {
    if (this.value === value) return;
    if (this.value > value) {
      for (let i = this.items.length - 1; i >= 0; i--) {
        const agreement = this.items[i];
        for (let i = agreement.requests.length - 1; i >= 0; i--) {
          const request = agreement.requests[i];
          request.value = 0;
          if (this.value < value) {
            let sum = value - this.value;
            request.value = value - this.value;
          }
        }
      }
    } else {
      this.items.forEach(agreement => {
        agreement.requests.forEach(request => {
          if (this.value < value) {
            let sum = value - this.value + request.value;
            request.value = sum > request.debtPay ? request.debtPay : sum;
          }
        })
      })
    }
  }


  add(code) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (!code) return reject();
      if (self.item(code)) return resolve(self.item(code));
      const agreement = new Item(code);
      agreement.setFilters(this._filter);
      self.items.push(agreement);
      self.tab = code;
      agreement.mask = this.mask;
      agreement.get().then(resolve, (err) => {
        self.remove(agreement.code);
        notification.error(err);
        reject(err);
      });
    });
  }

  edit(data) {
    const self = this;
    const code = data.Code;
    return new Promise((resolve, reject) => {
      if (self.item(code)) return resolve(self.item(code));
      const agreement = new Item(code);
      agreement.setFilters(this._filter);
      self.items.push(agreement);
      self.tab = code;
      agreement.edit = false;
      agreement.mask = this.mask;
      agreement.get().then(() => {
        agreement.requests.forEach(request => {
          const price = data.OrderPrices.find(i => i.RequestId === request.id);
          if (!price) return;
          request.course = price.Course;
          request.value = price.Spread;
          request.debt = request.debt + request.value2;
        });
        resolve(agreement);
      }, reject);
    });
  }

  regular(data) {
    const self = this;
    const code = data.Code;
    return new Promise((resolve, reject) => {
      if (self.item(code)) {
        self.item(code)._requests.forEach(request => {
          const price = data.OrderPrices.find(i => i.RequestId === request.id);
          if (!price) return;
          request.value += price.Spread;
        });
        return resolve(self.item(code));
      }
      const agreement = new Item(code);
      agreement.setFilters(this._filter);
      self.items.push(agreement);
      self.tab = code;
      agreement.edit = false;
      agreement.mask = this.mask;
      agreement.get().then(() => {
        agreement._requests.forEach(request => {
          if (request.getAgencyCourse) {
            request.getAgencyCourse();
          }
          const price = data.OrderPrices.find(i => i.RequestId === request.id);
          if (!price) return;
          request.value = price.Spread;
        });
        resolve(agreement);
      }, reject);
    });
  }

  remove(code) {
    this._items.remove(this.item(code));
  }

  item(code) {
    return this.items.find(agreement => agreement.code === code);
  }

  set(data) {
    this._filter.direction = data.direction;
    this._filter.contragentType = data.contragentType;
    this._filter.contragent = data.contragent;
    this._filter.legal = data.legal;
    this._filter.currency = data.currency;
    this.setItemsFilter();
  }

  setItemsFilter() {
    this.items.forEach(agreement => {
      agreement.setFilters(this._filter);
    })
  }

  setSum() {
    ///Не работает
    this.items.forEach(agreement => {
      agreement.setFilters(this._filter);
    })
  }
}